import { render, staticRenderFns } from "./ApplicationTemplate.vue?vue&type=template&id=424ddcc0&scoped=true"
import script from "./ApplicationTemplate.vue?vue&type=script&lang=ts"
export * from "./ApplicationTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424ddcc0",
  null
  
)

export default component.exports